// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    position: relative;
}

[data-default-home-tooltip-placeholder] {
    --default-home-tooltip-size: 40px;
    width: var(--default-home-tooltip-size);
    height: var(--default-home-tooltip-size);
    aspect-ratio: 1 / 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

[data-default-view-icon] {
    --md-outlined-icon-button-icon-size: 20px;
    --default-view-icon-size: 30px;
    height: var(--default-view-icon-size);
    width: var(--default-view-icon-size);
}

[data-default-home-icon-tips] {
    display: none;
    position: absolute;
    top: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/TabsLayout/components/DefaultHomeIconComponent/DefaultHomeIconComponent.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,uCAAuC;IACvC,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;IACzC,8BAA8B;IAC9B,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;AACb","sourcesContent":[":host {\n    position: relative;\n}\n\n[data-default-home-tooltip-placeholder] {\n    --default-home-tooltip-size: 40px;\n    width: var(--default-home-tooltip-size);\n    height: var(--default-home-tooltip-size);\n    aspect-ratio: 1 / 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n[data-default-view-icon] {\n    --md-outlined-icon-button-icon-size: 20px;\n    --default-view-icon-size: 30px;\n    height: var(--default-view-icon-size);\n    width: var(--default-view-icon-size);\n}\n\n[data-default-home-icon-tips] {\n    display: none;\n    position: absolute;\n    top: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
